<template>
  <div class="steps-container">
    <div class="steps-progress">
        <!-- Progress Bar Background -->
        <div class="progress-track"></div>
        <!-- Active Progress Bar -->
        <div class="progress-fill" :style="{ width: progressPercentage + '%' }"></div>
    </div>

    <div class="steps-items">
        <div
            v-for="data in steps"
            :key="data.step"
            class="step-item"
            :class="{
                'active': data.step === activeStep,
                'completed': data.step < activeStep,
                'pending': data.step > activeStep
            }"
        >
        <div class="step-indicator">
            <div class="step-circle">
                <i class="fas fa-check" v-if="data.step < activeStep"></i>
                <span v-else>{{ data.step }}</span>
            </div>
            <!-- Glow Effect for Active -->
             <div class="step-glow" v-if="data.step === activeStep"></div>
        </div>

        <span class="step-label d-none d-md-block">{{ data.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { steps } from '../router';

export default {
  data() {
    return {
      steps,
    };
  },
  computed: {
    activeStep() {
      return this.$route.meta.step;
    },
    progressPercentage() {
      if (!this.steps.length) return 0;
      // Calculate percentage: (activeStep - 1) / (totalSteps - 1) * 100
      // We want the line to reach the center of the active step
      const total = this.steps.length;
      if (total === 1) return 100;
      return ((this.activeStep - 1) / (total - 1)) * 100;
    },
  },
};
</script>

<style lang="scss" scoped>
$primary-color: #007D53;
$active-glow: rgba(0, 125, 83, 0.4);
$inactive-color: #e0e0e0;
$text-active: #2c3e50;
$text-inactive: #95a5a6;

.steps-container {
  padding: 30px 40px;
  position: relative;
  margin-bottom: 20px;
}

.steps-progress {
    position: absolute;
    top: 45px; // Align with center of circles (30px circle + padding)
    left: 40px;
    right: 40px;
    height: 4px;
    z-index: 0;
}

.progress-track {
    width: 100%;
    height: 100%;
    background-color: $inactive-color;
    border-radius: 4px;
}

.progress-fill {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    background: linear-gradient(90deg, $primary-color, lighten($primary-color, 10%));
    border-radius: 4px;
    transition: width 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.steps-items {
    display: flex;
    justify-content: space-between;
    position: relative;
    z-index: 1;
}

.step-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    width: 80px; // Fixed width for alignment

    &.active {
        .step-circle {
            background-color: $primary-color;
            color: white;
            border-color: $primary-color;
            transform: scale(1.1);
        }
        .step-label {
            color: $primary-color;
            font-weight: 700;
        }
    }

    &.completed {
        .step-circle {
             background-color: $primary-color;
             color: white;
             border-color: $primary-color;
        }
        .step-label {
            color: $primary-color;
        }
    }
}

.step-indicator {
    position: relative;
    width: 34px;
    height: 34px;
    margin-bottom: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.step-circle {
    width: 32px;
    height: 32px;
    background-color: white;
    border: 2px solid $inactive-color;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-weight: 600;
    color: $text-inactive;
    transition: all 0.3s ease;
    z-index: 2;
}

.step-glow {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 50px;
    height: 50px;
    background: $active-glow;
    border-radius: 50%;
    filter: blur(8px);
    z-index: 1;
    animation: pulse 2s infinite;
}

.step-label {
    font-size: 13px;
    font-weight: 500;
    color: $text-inactive;
    transition: color 0.3s ease;
    text-align: center;
    white-space: nowrap;
    position: absolute;
    top: 40px;
}

@keyframes pulse {
    0% { transform: translate(-50%, -50%) scale(0.95); opacity: 0.7; }
    50% { transform: translate(-50%, -50%) scale(1.1); opacity: 0.4; }
    100% { transform: translate(-50%, -50%) scale(0.95); opacity: 0.7; }
}
</style>
